import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { pushNotification } from "../../redux/actions/app";
import { enqueueAccessRequest, openGate } from "../../redux/actions/property";
import { selectValidUserCodes } from "../../redux/selectors/property";
import CancelButton from "../../components/CancelButton";
import {
  STRINGS,
  SK_MODEL,
  SK_MODELS,
  NORMALIZED_BUTTONS,
  NormalizedButtonEvent,
} from "../../common/normalized-hardware-models";
import firebase from "../../common/firebase";
import { History, Location, RootState, TypedDispatch } from "src";
import { createNotification } from "src/common/types";

const ACCESS_CODE_LENGTH = 5;

type ComponentProps = {
  history: History;
  location: Location;
  dispatch: TypedDispatch;
  validAccessCodes: string[];
};
type ComponentState = {
  accessCode: number[];
};

class EnterCode extends Component<ComponentProps, ComponentState> {
  state: ComponentState = {
    accessCode: [],
  };

  hardTimeout: number;

  constructor(props: ComponentProps) {
    super(props);

    const params = new URLSearchParams(props.location.search);
    const initialCode = params.get("initialCode");
    const accessCode: number[] = [];

    if (initialCode) {
      console.log(`Have partial access code ${initialCode} from main screen`);
      accessCode.push(Number(initialCode));
    }

    this.state = { accessCode };
    this.hardTimeout = 0;
  }

  static propTypes = {
    history: PropTypes.any.isRequired,
  };

  componentDidMount() {
    window.addEventListener("normalizedButtonEvent", this.handleButton);

    this.resetTimer();
  }

  componentWillUnmount() {
    window.removeEventListener("normalizedButtonEvent", this.handleButton);

    window.clearTimeout(this.hardTimeout);
  }

  resetTimer = () => {
    const { history } = this.props;

    clearTimeout(this.hardTimeout);
    this.hardTimeout = window.setTimeout(() => {
      history.replace("/");
    }, 60000);
  };

  handleButton = (e: NormalizedButtonEvent) => {
    const { history } = this.props;

    if (e.detail.button === NORMALIZED_BUTTONS.BACK) {
      history.replace("/");
    } else if (Number.isInteger(e.detail.button)) {
      this.handleAccessCodeInput(Number(e.detail.button));
    }
  };

  handleAccessCodeInput = (number: number) => {
    const { accessCode } = this.state;
    const { history, dispatch, validAccessCodes } = this.props;

    this.resetTimer();
    const nextAccessCode: number[] = accessCode;
    nextAccessCode.push(number);

    this.setState(
      (state: ComponentState) => ({
        accessCode:
          nextAccessCode.length === ACCESS_CODE_LENGTH ? [] : nextAccessCode,
      }),
      () => {
        if (nextAccessCode.length >= ACCESS_CODE_LENGTH) {
          const nextAccessCodeString = nextAccessCode.join("");
          console.log(`Have full access code ${nextAccessCodeString}`);
          const accessCodeValid = validAccessCodes.some(
            (code: string) => code === nextAccessCodeString
          );

          if (accessCodeValid) {
            firebase.logAnalyticsEvent("numeric_code_gate_unlock");
            dispatch(openGate(nextAccessCodeString));
            dispatch(enqueueAccessRequest(nextAccessCodeString, true));
          } else {
            dispatch(
              pushNotification(
                createNotification(
                  "ERROR",
                  "Sorry, that code didn't work",
                  null,
                  "sorryCode"
                )
              )
            );
            dispatch(enqueueAccessRequest(nextAccessCodeString, false));
          }

          history.replace("/");
        } else {
          console.log(`Have partial access code ${nextAccessCode.join("")}`);
        }
      }
    );
  };

  renderKeypad = () => {
    return (
      <div>
        <div>
          <button
            className="keypadNumber"
            type="button"
            onClick={() => this.handleAccessCodeInput(1)}
          >
            1
          </button>
          <button
            className="keypadNumber"
            type="button"
            onClick={() => this.handleAccessCodeInput(2)}
          >
            2
          </button>
          <button
            className="keypadNumber"
            type="button"
            onClick={() => this.handleAccessCodeInput(3)}
          >
            3
          </button>
        </div>
        <div>
          <button
            className="keypadNumber"
            type="button"
            onClick={() => this.handleAccessCodeInput(4)}
          >
            4
          </button>
          <button
            className="keypadNumber"
            type="button"
            onClick={() => this.handleAccessCodeInput(5)}
          >
            5
          </button>
          <button
            className="keypadNumber"
            type="button"
            onClick={() => this.handleAccessCodeInput(6)}
          >
            6
          </button>
        </div>
        <div>
          <button
            className="keypadNumber"
            type="button"
            onClick={() => this.handleAccessCodeInput(7)}
          >
            7
          </button>
          <button
            className="keypadNumber"
            type="button"
            onClick={() => this.handleAccessCodeInput(8)}
          >
            8
          </button>
          <button
            className="keypadNumber"
            type="button"
            onClick={() => this.handleAccessCodeInput(9)}
          >
            9
          </button>
        </div>
        <div className="center">
          <button
            className="keypadNumber"
            type="button"
            onClick={() => this.handleAccessCodeInput(0)}
          >
            0
          </button>
        </div>
      </div>
    );
  };

  render() {
    const { accessCode } = this.state;
    const { history } = this.props;

    const displayCode = new Array(ACCESS_CODE_LENGTH).fill(0).map((_, i) =>
      i in accessCode ? (
        <span className="primary" key={`${accessCode[i]}-${i}`}>
          *
        </span>
      ) : (
        <span className="muted" key={`dash-${i}`}>
          -
        </span>
      )
    );

    return (
      <div className="wrapper">
        <h1 className="page-title">{STRINGS.CODE_INPUT_TITLE}</h1>
        <div className="centered-box">
          <div className="inputCode">{displayCode}</div>
          {SK_MODEL === SK_MODELS.TOUCH && this.renderKeypad()}
        </div>
        <div className="footer-actions">
          <CancelButton onClick={() => history.replace("/")} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  validAccessCodes: selectValidUserCodes(state),
});

export default connect(mapStateToProps)(EnterCode);
